import { useLocation } from 'react-router-dom';
import { EDIT_URL_REGEX } from 'settings/regex';

function useIsEditProduct(): {
  editUrl: string | undefined;
} {
  const { pathname } = useLocation();
  const match = pathname.match(EDIT_URL_REGEX);

  return {
    editUrl: match?.length ? match[0] : undefined,
  };
}

export default useIsEditProduct;
